import React from 'react';

export class Toggle extends React.PureComponent {
  renderOption = (o) => {
    const { activeOption, onChange } = this.props;

    return (
      <button
        key={o}
        type="button"
        name={o}
        className={`btn ${o === activeOption && 'active'}`}
        onClick={onChange}
      >
        {o}
      </button>
    );
  };

  render() {
    const { options } = this.props;

    return (
      <div className="toggle" onClick={this.onStatusChange}>
        {options.map(this.renderOption)}
      </div>
    );
  }
}
